import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr, saveFile } from '@/utils/index';
import Cookies from 'js-cookie';
import UploadHelpFile from '@/components/System/helpDoc/uploadHelpFile';
export default {
  components: {
    SearchForm: SearchForm,
    NoData: NoData,
    UploadHelpFile: UploadHelpFile
  },
  data: function data() {
    return {
      showLoading: false,
      searchFormData: [{
        title: '所属系统',
        key: '',
        placeholder: '请选择所属系统',
        type: 'select',
        selectData: [],
        selectedArr: '',
        value: ''
      }, {
        title: '文档名称',
        key: 'role',
        placeholder: '请输入文档名称关键词',
        type: 'input',
        value: null,
        selectData: [],
        selectedArr: []
      }],
      btnType: 'search,reset,upload',
      tableData: [],
      total: 0,
      tableheight: 512,
      userId: '',
      searchObj: {
        fileName: '',
        systemId: '',
        pageSize: 10,
        pageNum: 1
      },
      showUploadfile: false
    };
  },
  created: function created() {
    this.userId = Cookies.get('user_id');
    // this.searchForm(this.searchFormData)
    this.getSystemList();
    this.getHelpDoc();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  methods: {
    getSystemList: function getSystemList() {
      var _this = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        if (res.code === '0000000000') {
          res.result.records.forEach(function (item) {
            var selectvalue = {
              value: item.systemId,
              label: item.systemName
            };
            _this.searchFormData[0].selectData.push(selectvalue);
          });
        }
      });
    },
    getHelpDoc: function getHelpDoc() {
      var _this2 = this;
      this.showLoading = true;
      this.$API.postRequest({
        url: '/platform/helpDoc/list',
        data: this.searchObj
      }).then(function (res) {
        _this2.showLoading = false;
        // if (res.code === '200') {
        _this2.tableData = res.result.records;
        _this2.total = res.result.total;
        // }
      });
    },
    searchForm: function searchForm(obj) {
      this.searchObj.fileName = obj[1].value;
      this.searchObj.systemId = obj[0].selectedArr;
      this.searchObj.pageNum = 1;
      this.getHelpDoc();
    },
    currentChange: function currentChange(page) {
      this.searchObj.pageNum = page;
      this.getHelpDoc();
    },
    sizeChange: function sizeChange(size) {
      this.searchObj.pageSize = size;
      this.getHelpDoc();
    },
    getChangeSelect: function getChangeSelect(item) {
      this.searchFormData.selectedArr = item.selectedArr;
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    resetForm: function resetForm() {
      this.searchFormData[0].selectedArr = '';
      this.searchFormData[1].value = '';
      this.searchObj.fileName = '';
      this.searchObj.systemId = '';
      this.searchObj.pageNum = 1;
      this.getHelpDoc();
    },
    uploadFile: function uploadFile() {
      this.showUploadfile = true;
    },
    downloadfile: function downloadfile(scope) {
      this.$API.getRequest({
        // eslint-disable-next-line no-useless-concat
        url: '/platform/helpDoc/download?' + "id=".concat(scope.row.id, "&download=1"),
        responseType: 'blob'
      }).then(function (res) {
        saveFile(res.data, scope.row.docName);
      });
    },
    confirmdel: function confirmdel(obj, bool) {
      if (bool) {
        this.deletefile(obj);
      }
    },
    deletefile: function deletefile(scope) {
      var _this3 = this;
      this.$API.delRequest({
        url: "/platform/helpDoc/id?id=".concat(scope.row.id)
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.getHelpDoc();
        }
      });
    },
    gotoDetail: function gotoDetail(scope) {
      this.$router.push({
        path: '/system/helpDoc/helpPdf',
        query: {
          helpDocId: scope.row.id
        }
      });
    },
    helpFileAddSubmit: function helpFileAddSubmit(data) {
      var _this4 = this;
      if (data.bool) {
        this.$API.postRequest({
          url: '/platform/helpDoc/submit',
          data: data.formData
        }).then(function () {
          _this4.showUploadfile = false;
          _this4.$message({
            message: '上传成功！',
            type: 'success'
          });
          _this4.getHelpDoc();
        });
      } else {
        this.showUploadfile = false;
      }
    }
  }
};